/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var EyeOpenIcon24Solid = forwardRef('EyeOpenIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M9 12a3 3 0 1 1 6 0 3 3 0 0 1-6 0Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 3.486C6.566 3.486 1.917 6.841.079 11.58a1.16 1.16 0 0 0 0 .84C1.917 17.159 6.566 20.514 12 20.514c5.434 0 10.083-3.355 11.921-8.094a1.16 1.16 0 0 0 0-.84C22.083 6.841 17.434 3.486 12 3.486Zm0 3.264a5.25 5.25 0 1 0 0 10.5 5.25 5.25 0 0 0 0-10.5Z" })));
});
